import { Expose, Type } from "class-transformer";

class UserSegment {
    @Expose({ name: "codigoSegmentacion" })
    @Type(() => Number)
    code = 0;
}

export { UserSegment };
